import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { RECEPTION_MODULE_NAMESPACE, RECEPTION_GET_RECEPTIONS, RECEPTION_SET_VALUE_BY_FIELD, RECEPTION_RESET_RECEPTIONS, RECEPTION_SET_LOADER_STATE, RECEPTION_LOADERS } from '../../../store/reception/reception-types.store'
import { IPagination } from '../../../models/generic'
import { IReceptionParameter, IReceptionListingViewModel } from '../../../models/reception'
import { ActivityStatus } from '../../../common/enums'
const ReceptionStore = namespace(RECEPTION_MODULE_NAMESPACE)
@Component({
  components: {
    'list-condition': async () => import('../components/mh-reception-conditions/MHReceptionConditions.vue'),
    'list-item': async () => import('../components/mh-reception-list-item/MHReceptionListItem.vue'),
    'reception-list-loader': async () => import('../loaders/reception-list-loader/ReceptionListLoader.vue')
  }
})
class MHReceptionChildListContainer extends Vue {

  constructor () {
    super()
  }

  beforeMount(){
    if(this.$route.path.includes('/vehicle-check'))
    {
      this.storeAssignValueForReceptionParameter({type:'vehicle'})
    } else {
      this.storeAssignValueForReceptionParameter({type:null})
    }
  }

  mounted () {}

  @ReceptionStore.Getter activityStatus: ActivityStatus;
  @ReceptionStore.Getter pagination: IPagination;
  @ReceptionStore.Getter receptionParameter: IReceptionParameter;
  @ReceptionStore.Getter receptionsSource: {
    activityStatus: ActivityStatus,
    data: IReceptionListingViewModel[]
  };

  @ReceptionStore.Mutation(RECEPTION_SET_VALUE_BY_FIELD)
  storeAssignValueForReceptionParameter: (value: { [x: string]: any }) => void;

  @ReceptionStore.Action(RECEPTION_GET_RECEPTIONS)
  storeGetReceptions: (payload: { param: IReceptionParameter, merge: boolean }) => Promise<any>;

  @ReceptionStore.Mutation(RECEPTION_RESET_RECEPTIONS)
  storeResetReceptions: () => void;

  @ReceptionStore.Mutation(RECEPTION_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void

  get lblSetting () {
    return {
      ...require('@/locales/reception').default
    }
  }
  get receptionsViewModel (): IReceptionListingViewModel[] {
    return this.receptionsSource.data
  }
  get coSearchParameter (): IReceptionParameter {
    return this.receptionParameter
  }
  set coSearchParameter (value: IReceptionParameter) {
    this.storeAssignValueForReceptionParameter(value)
  }

  get searchParam () {
    return { param: this.coSearchParameter, merge: true }
  }

  setListLoaderState (value: boolean) {
    this.storeSetLoaderState({ key: RECEPTION_LOADERS.LIST, value })
  }

  @Watch('$route.path')
  changeRoute(newV,oldV)
  {
    //console.log(newV,oldV)
    if(newV!==oldV)
    {
      this.storeResetReceptions()
      if(newV.includes('/vehicle-check'))
      {
        this.storeAssignValueForReceptionParameter({type:'vehicle'})
      } else {
        this.storeAssignValueForReceptionParameter({type:null})
      }
      this.storeGetReceptions(this.searchParam)
    }
  }
}

export default MHReceptionChildListContainer



// WEBPACK FOOTER //
// ./src/containers/mh-reception/mh-reception-child-list/index.ts